module.exports = __webpack_public_path__ + "static/media/shapes-ellipse.26465dc0.svg";